module.exports = __webpack_public_path__ + "img/money-bill-1-wave.816d00e4.svg";